<template>
  <div class="aboutus-page">
    <header-cmp></header-cmp>

    <!-- banner图 开始-->
    <section class="page-part banner banner_aboutus"></section>
    <!-- banner图 结束-->

    <section class="page-part page-container">
      <div class="page-inner">
        <aside class="menu" ref="menu">
          <ul>
            <li
              v-for="(item, index) in menuList"
              :key="index"
              class="menu-item"
              :class="activedIndex == index ? 'active' : ''"
              @click="clickMenuHandler(item, index)"
            >
              {{ item.alias }}
            </li>
          </ul>
        </aside>
        <article class="inline-block content" ref="content">
          <section id="jianjie" class="inline-block">
            <h3 class="section-title">公司简介</h3>
            <p
              class="section-desc inline-block"
              style="width: 415px; margin-right: 10px; vertical-align: unset;"
            >
              杭州享运供应链管理有限公司是一家基于大数据的大宗商品智能车货匹配交易平台。截止2017年6月平台已有7000多用户，与浙江物产、宝钢、吉利汽车等世界500强企业及乐钢、找钢、欧冶及塑料领域的优秀大宗电商企业达成了战略合作伙伴关系。享运基础物流产品不断创新，于2016年11月“享运货主”、“享运司机”车货匹配交易APP正式上线同时开发了微信版和PC版。系统下单简洁，快速派车，安装享运司机的司机端北斗定位实时反馈给货主。享运APP解决了货主找车难、司机找货难得问题，提高了司机的接单频次，减少了司机的空驶现象，降低了社会的能耗，让物流更低碳。同时平台提供给货主和司机的双方保障。享运平台粘性产品不断创新，享运要“做最好的物流服务商，打造一流的供应链体系”。
            </p>
            <div class="relative inline-block">
              <img
                class="section-img inline-block"
                v-show="hiddenVideo"
                src="../assets/images/page_aboutus/video_snapshot.png"
                style="width: 500px; vertical-align: super; cursor: pointer"
              />
              <video
                preload
                controls
                loop
                ref="introVideo"
                :hidden="hiddenVideo"
                src="http://www.clfirst.com/videos/ceo_introduction.6a89b70.mp4"
                class="section-img"
                style="width: 500px; vertical-align: super;"
              />

              <div class="banner-cover" @click="playVideo" v-show="hiddenVideo">
                <i class="icon icon-play"></i>
              </div>
            </div>
          </section>

          <section id="licheng">
            <h3 class="section-title">发展历程</h3>
            <div class="pairs">
              <span class="key">2010</span>
              <span class="value"
                >章双荷2008年毕业于浙江工商大学（杭商院）首届物流管理专业，先后供职过宅急送和华冶钢铁，随后创办了观海物流。</span
              >
            </div>
            <div class="pairs">
              <span class="key">2011</span>
              <span class="value"
                >全国服务热线0571-88769096开通，购买了第一辆卡车。</span
              >
            </div>
            <div class="pairs">
              <span class="key">2012</span>
              <span class="value"
                >观海企业QQ开通，对外统一形象窗口对内统一管理 。</span
              >
            </div>
            <div class="pairs">
              <span class="key">2013</span>
              <span class="value"
                >观海物流的图形商标下证，业绩突破1000万。</span
              >
            </div>
            <div class="pairs">
              <span class="key">2014</span>
              <span class="value"
                >与吉利汽车和宝钢签订运输战略协议，观海物流微信公众号开通。</span
              >
            </div>
            <div class="pairs">
              <span class="key">2015</span>
              <span class="value"
                >观海物流“观海”的文字商标下证，第一个合伙人加入观海，提出了“物流+互联网”的发展思路，注册成立“杭州享运供应链管理有限公司”，进行线上运营，与观海物流线上模式结合
                ，线上线下同步发展。</span
              >
            </div>
            <div class="pairs">
              <span class="key">2016</span>
              <span class="value"
                >2016年是观海的拐点，今年7月份观海旗下产品“享运网”APP和微信端面世，届时广大客户可以通过APP和微信下单，业务覆盖全国，遵循价格更优和承运效率更高的原则，更好的服务广大客户。
                杭州享运供应链管理有限公司属于杭州观海物流有限公司的全资子公司，注册资金500万，由原观海物流的原班人马打造。</span
              >
            </div>
            <div class="pairs">
              <span class="key">2017</span>
              <span class="value">敬请期待……</span>
            </div>
          </section>

          <section id="yuanjing">
            <h3 class="section-title">企业愿景</h3>
            <p>成为最卓越的大宗商品智能物流平台！</p>
          </section>

          <section id="shiming">
            <h3 class="section-title">企业使命</h3>
            <p>让物流更美好、更高效、更智能！</p>
          </section>

          <section id="jiazhiguan">
            <h3 class="section-title">价值观</h3>
            <p>客户至上 激情快乐 创新思维 高效执行</p>
          </section>

          <section id="lianxi">
            <h3 class="section-title">联系我们</h3>
            <h4 class="section-title_sub">杭州享运供应链管理有限公司</h4>
            <p class="section-desc">地址：浙江省杭州市余杭区良渚街道网周路99号1幢1901室 </p>
            <!-- <img class="map" src="../assets/images/page_aboutus/map_pic.png" alt="企业地址"> -->
            <div id="map-wrap">
               <img src="@/assets/images/gsdz.png" alt="" class="map" />
            </div>
          </section>

          <p class="hotline">全国服务热线：0571-88769096</p>
        </article>
      </div>
    </section>

    <footer-cmp></footer-cmp>
  </div>
</template>

<script type="text/ecmascript-6">
import HeaderCmp from '@/components/header';
import FooterCmp from '@/components/footer';

export default {
  name: 'aboutusPage',
  components: {
    HeaderCmp,
    FooterCmp
  },
  data() {
    return {
      menuList: [{
          name: 'jianjie',
          alias: '公司简介'
        },
        {
          name: 'licheng',
          alias: '发展历程'
        },
        {
          name: 'yuanjing',
          alias: '企业愿景'
        },
        {
          name: 'shiming',
          alias: '企业使命'
        },
        {
          name: 'jiazhiguan',
          alias: '价值观'
        },
        {
          name: 'lianxi',
          alias: '联系我们'
        }
      ],
      activedIndex: -1,
      hiddenVideo: true
    }
  },
  methods: {
    clickMenuHandler(item, index) {
      this.$utils.goAnchor(this, `#${item.name}`, -100);
      this.activedIndex = index;
    },
    playVideo() {
      this.hiddenVideo = false;
      const video = this.$refs.introVideo;
      video.muted = true;
      video.play();
    },
    initMap( ) {
      /* eslint-disable */
      // var map = new BMap.Map("map-wrap"); // 创建Map实例
      // const point = new BMap.Point(120.065937,30.368184);
      // map.centerAndZoom(point, 18); // 初始化地图,设置中心点坐标和地图级别
      // //添加地图类型控件
      // map.addControl(
      //   new BMap.MapTypeControl({
      //     mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
      //   })
      // );
      // map.addControl(
      //   new BMap.NavigationControl({
      //     // 靠左上角位置
      //     anchor: BMAP_ANCHOR_TOP_LEFT,
      //     // LARGE类型
      //     type: BMAP_NAVIGATION_CONTROL_LARGE
      //   })
      // );
      // map.setCurrentCity("杭州"); // 设置地图显示的城市 此项是必须设置的
      // // map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      // var marker = new BMap.Marker(point); // 创建标注
      // map.addOverlay(marker);
      // var opts = {
      //   position: point, // 指定文本标注所在的地理位置
      //   offset: new BMap.Size(5, -40) //设置文本偏移量
      // };
      // var label = new BMap.Label("浙江省杭州市余杭区良渚街道网周路99号1幢1901室 ", opts); // 创建文本标注对象
      // label.setStyle({
      //   color: "red",
      //   fontSize: "12px",
      //   height: "20px",
      //   lineHeight: "20px",
      //   fontFamily: "微软雅黑"
      // });
      // map.addOverlay(label);
      /* eslint-enable */
    }
  },
  mounted() {
    // this.initMap();
    this.$utils.watchRouteGoAnchor(this);
    // 找到对应的DOM，并获取起相对document的上高度
    const sectionItems = this.menuList.map(item => {
      let selector = '#' + item.name;
      let section = document.querySelector(selector);
      return {
        el: section,
        start: section.offsetTop,
        end: section.clientHeight + section.offsetTop
      };
    });

    // 注册监听事件
    window.onscroll = () => {
      sectionItems.forEach((section, index) => {
        if (section.start < window.scrollY && window.scrollY < section.end) {
          this.activedIndex = index;
        }
      });
      if (
        window.scrollY >= sectionItems[0].start &&
        window.scrollY <= sectionItems[sectionItems.length - 1].start + 200
      ) {
        this.$refs.menu.style.position = 'fixed';
        this.$refs.content.style.marginLeft = '165px';
      } else {
        this.$refs.menu.style.position = 'initial';
        this.$refs.content.style.marginLeft = '30px';
      }
    }
  },
  beforeDestroy() {
    window.onscroll = null;
  },
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../style/_variable";
#map-wrap {
  margin-top: 20px;
  width: 100%;
  height: 500px;
}
.aboutus-page {
  width: 100%; // banner图
  .banner {
    height: 500px;
    &_aboutus {
      background: url("../assets/images/page_aboutus/banner5.png") center
        no-repeat;
      background-size: 100% 100%;
      -moz-background-size: 100% 100%;
    }
  }
  .icon-play {
    width: 50px;
    height: 50px;
    background: url("../assets/images/icon/play.png") center no-repeat;
    background-size: 50px;
    opacity: 0.4;
    transition: all 0.5s;
  }
  .banner-cover {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.2);
    transition: all 0.5s;
    &:hover {
      background-color: rgba(255, 255, 255, 0.4);
      .icon-play {
        opacity: 1;
      }
    }
  }
  .page-container {
    padding: 90px 0 132px 0;

    .menu {
      display: inline-block;
      width: 132px;
      top: 100px;

      &-item {
        color: $text-clr;
        font-size: 18px;
        font-weight: bold;
        padding: 24px 0;
        border-top: 1px solid $border-clr;
        cursor: pointer;
        &.active {
          color: $text-clr_primary;
        }
        &:last-child {
          border-bottom: 1px solid $border-clr;
        }
      }
    }

    .content {
      vertical-align: top;
      width: 930px;
      margin-left: 30px;

      section {
        margin-bottom: 50px;
      }
    }

    .section-title {
      color: $text-clr_primary;
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 12px;
      border-bottom: 1px solid $boder-clr_dark;
      margin-bottom: 36px;
      &_sub {
        font-weight: bold;
      }
    }
    .section-desc {
      color: $text-clr_light;
      font-size: 14px;
      line-height: 2;
    }

    #jianjie {
      .section-desc {
        width: 540px;
        vertical-align: top;
        margin-right: 20px;
      }
      .inline-block {
        display: inline-block;
      }
      .section-img {
        width: 360px;
      }
      .relative {
        position: relative;
      }
    }

    #licheng {
      .pairs {
        width: 100%;
        margin: 37px 0;
        .key {
          width: 7%;
          display: inline-block;
          vertical-align: top;
          font-size: 16px;
          font-weight: 400;
          color: $text-clr_primary;
        }
        .value {
          width: 90%;
          display: inline-block;
          font-size: 14px;
          color: $text-clr_light;
        }
      }
    }

    #lianxi {
      .map {
        margin-top: 10px;
      }
    }

    .hotline {
      font-size: 24px;
      margin-top: -40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus.vue